import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CapabilitiesResponseDataSchema } from "schema"
import z from "zod"

const getInstalledCapabilitiesQueryKey = () => ["capabilities", "installed"]

type Response = {
  data: z.infer<typeof CapabilitiesResponseDataSchema>
}

type Props = {
  enabled?: boolean
}

export const capabilitiesQuery = ({ enabled }: Props = {}) => {
  return queryOptions({
    queryKey: getInstalledCapabilitiesQueryKey(),
    queryFn: async () => {
      const response = await axios.get<Response>("/capabilities")

      return response.data.data
    },
    enabled,
  })
}
